import('./index');

// import '@olx/laquesis-surveys/dist/surveys_panamera.css';
import 'panamera-react-ui/dist/styles/all.scss';
import './bootStrap.scss';
